import { Link } from "react-router-dom";
import { PageShell } from "../components/PageShell";
import { SEO } from "../components/page/SEO";

export default function NotFoundPage() {
  return (
    <PageShell>
      <SEO title="404 — Page Not Found | Built Different Hockey" description="The page you're looking for doesn't exist or has moved." canonical="/404" noindex />
      <section className="bg-[#0a0a0a] min-h-[60vh] flex items-center">
        <div className="mx-auto max-w-[900px] px-6 md:px-10 lg:px-16 py-20 text-center">
          <p className="overline">404</p>
          <h1 className="font-display text-5xl md:text-7xl uppercase mt-5 leading-[0.9]">
            Off the ice.
          </h1>
          <p className="text-zinc-400 mt-6 max-w-md mx-auto">
            That page either doesn't exist or has moved. Try heading home, or jumping straight to a program.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="btn-primary" data-testid="notfound-home-link">
              Back Home
            </Link>
            <Link to="/programs" className="btn-ghost !py-3 !px-5 !text-xs" data-testid="notfound-programs-link">
              See Programs
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
